<template>
  <div class="box">
    <div class="box-header">
      <div class="col-3 col-md-3 col-sm-8 col-xs-8">
        <select
          name="status"
          v-model="selectedFilter"
          @change="onChangeFilter()"
          style="width: auto;"
          class="form-control form-filtro"
        > 
          <option v-for="(item, index) in filtroStatus" :key="index" :value="item">{{ item.name }}</option>
        </select>
      </div>

      <div class="col-4 col-md-4 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input
              v-model="filterText"
              @keyup.enter="doFilter"
              type="text"
              class="form-control pull-right"
              placeholder="Pesquisar..."
            />
            <div class="input-group-btn">
              <button type="button" class="btn btn-info" @click="doFilter">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-5 col-md-5 col-sm-4 col-xs-4 div-btn-novo">
        <button
          v-if="status == 1"
          id="newButton"
          class="btn btn-sm btn-primary btn-novo"
          @click="novo()"
          style="width: 33px"
          data-tooltip="Novo"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
        &nbsp;
        <button
          class="btn btn-sm btn-default btn-novo"
          @click="atualizar()"
          style="width: 33px"
          data-tooltip="Atualizar"
        >
          <i class="fa fa-refresh" aria-hidden="true"></i>
        </button>
        &nbsp;
        <button
          class="btn btn-sm btn-warning btn-novo"
          @click="alterarStatus()"
          style="width: 33px"
          data-tooltip="Alterar Status"
        >
          <i class="glyphicon glyphicon-pencil" aria-hidden="true"></i>
        </button>
        &nbsp;
        <export-excel
          :fields="listaExcelFields"
          :fetch="gerarExcel"
          type="xls"
          worksheet="Motoristas"
          name="zanzar-motoristas.xls"
          class="btn btn-sm btn-primary btn-novo"
          style="width: 33px"
          data-tooltip="Exportar Excel"
        >
          <i class="fa fa-file-excel"></i>
        </export-excel>
      </div>

      <div
        class="col-12 col-md-12 col-sm-12 col-xs-12"
        style="border-top: 1px dashed #d2d6de; border-bottom: 1px dashed #d2d6de; margin-top: 10px;"
      >
        <div class="row">
          <div class="form-group col-6 col-md-1 div-form-filtro">
            <select
              v-model="filtro.uf"
              style="width: auto;"
              class="form-control form-filtro"
            >
              <option value="" selected>UF</option>
              <option value="AC">AC</option>
              <option value="AL">AL</option>
              <option value="AM">AM</option>
              <option value="AP">AP</option>
              <option value="BA">BA</option>
              <option value="CE">CE</option>
              <option value="DF">DF</option>
              <option value="ES">ES</option>
              <option value="GO">GO</option>
              <option value="MA">MA</option>
              <option value="MG">MG</option>
              <option value="MS">MS</option>
              <option value="MT">MT</option>
              <option value="PA">PA</option>
              <option value="PB">PB</option>
              <option value="PE">PE</option>
              <option value="PI">PI</option>
              <option value="PR">PR</option>
              <option value="RJ">RJ</option>
              <option value="RN">RN</option>
              <option value="RO">RO</option>
              <option value="RR">RR</option>
              <option value="RS">RS</option>
              <option value="SC">SC</option>
              <option value="SE">SE</option>
              <option value="SP">SP</option>
              <option value="TO">TO</option>
            </select>
          </div>
          <div class="form-group col-6 col-md-5 div-form-filtro">
            <input
              v-model="filtro.cidade"
              type="text"
              class="form-control form-filtro"
              placeholder="Cidade"
            />
          </div>
          <div
            class="form-group col-6 col-md-3 div-form-filtro"
            style="display: flex;"
          >
            <input
              v-model="filtro.media_ini"
              type="text"
              v-mask="'##########'"
              class="form-control form-filtro"
              style="width: 65px;"
              placeholder="Média"
            />
            &nbsp; até &nbsp;
            <input
              v-model="filtro.media_fim"
              type="text"
              v-mask="'##########'"
              class="form-control form-filtro"
              style="width: 65px;"
              placeholder="Média"
            />
          </div>
          <div class="form-group col-6 col-md-3 div-form-filtro">
            <div class="btn-group">
              <button type="button" class="btn btn-success" @click="filtrar()" style="padding: 3px; width: 60px">Filtrar</button>
              <button type="button" class="btn btn-default" @click="limparFiltro()" style="padding: 3px; width: 60px">Limpar</button>
            </div>
          </div>
          <div
            class="col-12 col-md-12"
            style="text-align: center; color: red; padding-bottom: 10px;"
            v-show="errorFiltroMessage"
          >
            {{ errorFiltroMessage }}
          </div>
        </div>
        <div class="row">
          <div class="form-group col-6 col-md-1 div-form-filtro">
            <select
              v-model="filtro.categoria"
              style="width: auto;"
              class="form-control form-filtro"
            >
              <option value="">Categoria</option>
              <option v-for="(item, index) in categorias" v-bind:value="item.cd_aplicativo_categoria" :key="index">{{ item.descricao }}</option>
            </select>
          </div>
          
          <div class="form-group col-6 col-md-1 div-form-filtro" style="margin-left: 5rem;">
            <input
              v-model="filtro.placa"
              @input="filtro.placa = filtro.placa.toUpperCase()"
              type="text"
              class="form-control form-filtro"
              placeholder="Placa"
              style="width: 12rem;"
            />
          </div>
        </div>
      </div>
    </div>

    <vuetable
      ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      track-by="cd_motorista"
      pagination-path=""
      :per-page="25"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"
      @vuetable:loaded="onLoaded"
      no-data-template="Nenhum registro encontrado"
    >
      <template slot="status_desc" slot-scope="props">
        <span
          class="label"
          v-bind:class="{
            'label-success': props.rowData.idc_status === 1,
            'label-danger': props.rowData.idc_status === 2,
            'label-warning': props.rowData.idc_status === 3,
            'label-info': [4, 5, 6].includes(props.rowData.idc_status),
            'label-default': ![1, 2, 3, 4].includes(props.rowData.idc_status)
          }"
        >{{ props.rowData.status_desc }}</span>
      </template>
      <template slot="actions" slot-scope="props">
        <div class="table-button-container" style="text-align: center">
          <div class="btn-group">
            <a
              @click="view(props.rowData)"
              class="btn btn-sm btn-success legitRipple"
              data-tooltip="Abrir"
              data-delay="500"
              data-hasqtip="0"
              aria-describedby="qtip-0"
              ><span class="glyphicon glyphicon-eye-open"></span
            ></a>
            <a
              @click="editar(props.rowData)"
              class="btn btn-sm btn-warning legitRipple"
              data-tooltip="Editar"
              data-delay="500"
              data-hasqtip="0"
              aria-describedby="qtip-0"
              ><span class="glyphicon glyphicon-pencil"></span
            ></a>
            <!-- <a @click="excluir(props.rowData)" class="btn btn-sm btn-danger legitRipple" data-tooltip="Remover" data-delay="500" data-hasqtip="1"><span class="glyphicon glyphicon-trash"></span></a> -->
          </div>
        </div>
      </template>
    </vuetable>

    <div
      class="row vuetable-pagination ui basic segment grid"
      style="padding: 10px"
    >
      <vuetable-pagination-info
        ref="paginationInfo"
        :css="css.pagination"
        info-template="Exibindo {from} - {to} de {total}"
        no-data-template=""
      />
      <vuetable-pagination
        ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        style="margin: 0"
      />
    </div>

    <modal name="modal-motorista" :adaptive="false" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="$modal.hide('modal-motorista')"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
          <div v-show="errorMessageModal != ''" class="alert alert-danger">
            {{ errorMessageModal }}
          </div>
          {{ bodyModal }}
          <br /><br />
          <label for="idc_status">Novo Status</label>
          <select
            id="idc_status"
            v-model="idc_status"
            style="width: auto"
            class="form-control form-filtro"
            v-bind:class="{ 'box-input-required': errors.idc_status }"
          >
            <option value="1">Ativo</option>
            <option value="2">Reprovado</option>
            <option value="13">Aguardando Pré-análise</option>
            <option value="3">Aguardando Validação</option>
            <option value="4">Agendamento Solicitado</option>
            <option value="5">Aguardando Agendamento</option>
            <option value="6">Aguardando Ponto de Apoio</option>
            <option value="7">Aguardando Equipamento</option>
            <option value="8">Agendamento Realizado</option>
            <option value="14">Cadastro não Finalizado - Pré-aprovado</option>
            <option value="9">Excluído</option>
            <option value="10">Outras Praças</option>
            <option value="11">Pendente</option>
            <option value="12">Furto, Roubo ou Avaria</option>
            <option value="15">Serasa</option>
          </select>
          <span v-show="errors.idc_status != null" class="help-inline">{{
            errors.idc_status
          }}</span>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default pull-left"
            @click="$modal.hide('modal-motorista')"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="modalMotoristaConfirma()"
          >
            Confirmar
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="modal-erro"
      :adaptive="false"
      width="600"
      height="auto"
      class="modal-danger"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="$modal.hide('modal-erro')"
          >
            <span aria-hidden="true">×</span>
          </button>
          <h3 class="modal-title">{{ titleModal }}</h3>
        </div>
        <div class="modal-body">
          <div v-html="bodyModal"></div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            @click="$modal.hide('modal-erro')"
          >
            Fechar
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import Vue from "vue";
import {
  Vuetable,
  VuetablePagination,
  VuetablePaginationInfo
} from "vuetable-2";
import VuetableCss from "./../../helpers/VuetableCss";

import AplicativoActions from "../../actions/AplicativoActions";
import AplicativoCategoriaActions from "../../actions/AplicativoCategoriaActions";
import AplicativoSegmentoActions from "../../actions/AplicativoSegmentoActions";
import ActionsLogin from "../../actions/LoginActions";
import MotoristaActions from "../../actions/MotoristaActions";

export const playerColumn = {
  name: "motorista_equipamento.0.equipamento.cd_player",
  title: "Player",
  sortField: "cd_player",
  visible: this.status === 1
};

export default {
  name: "Listar",
  props: ["titulo", "status"],
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data() {
    return {
      titleModal: "",
      bodyModal: "",
      errorMessageModal: "",
      errors: {},
      idc_status: "",
      css: VuetableCss,
      selectedFilter: { 
        name: "Listar Todos", 
        link: "/motoristas", 
        icon: "fas fa-caret-right" 
      },
      filtroStatus: [
        { 
          name: "Listar Todos", 
          link: "/motoristas", 
          icon: "fas fa-caret-right" 
        },
        {
          name: "Aguardando Pré-análise",
          link: "/motoristas/listar-aguardando-pre-analise",
          icon: "fas fa-caret-right"
        },
        {
          name: "Aguardando Validação",
          link: "/motoristas/listar-em-validacao",
          icon: "fas fa-caret-right"
        },
        {
          name: "Agendamento Solicitado",
          link: "/motoristas/listar-agendamento-solicitado",
          icon: "fas fa-caret-right"
        },
        {
          name: "Aguardando Agendamento",
          link: "/motoristas/listar-aguardando-agendamento",
          icon: "fas fa-caret-right"
        },
        {
          name: "Aguardando Ponto de Apoio",
          link: "/motoristas/listar-aguardando-ponto-apoio",
          icon: "fas fa-caret-right"
        },
        {
          name: "Aguardando Equipamento",
          link: "/motoristas/listar-aguardando-equipamento",
          icon: "fas fa-caret-right"
        },
        {
          name: "Agendamento Realizado",
          link: "/motoristas/listar-agendamento-realizado",
          icon: "fas fa-caret-right"
        },
        {
          name: "Ativos",
          link: "/motoristas/listar-ativos",
          icon: "fas fa-caret-right"
        },
        {
          name: "Reprovados",
          link: "/motoristas/listar-reprovados",
          icon: "fas fa-caret-right"
        },
        {
          name: "Excluídos",
          link: "/motoristas/listar-excluidos",
          icon: "fas fa-caret-right"
        },
        {
          name: "Outras Praças",
          link: "/motoristas/listar-outras-pracas",
          icon: "fas fa-caret-right"
        },
        {
          name: "Pendentes",
          link: "/motoristas/listar-pendentes",
          icon: "fas fa-caret-right"
        },
        {
          name: "Furto, Roubo ou Avaria",
          link: "/motoristas/listar-furto-roubo-avaria",
          icon: "fas fa-caret-right"
        },
        {
          name: "Cad. não Finali. - Pré-aprovado",
          link: "/motoristas/listar-cadastro-nao-finalizado-pre-aprovado",
          icon: "fas fa-caret-right"
        },
        {
          name: "Serasa",
          link: "/motoristas/listar-serasa",
          icon: "fas fa-caret-right"
        }
      ],
      listaExcelFields: {
        Codigo: "cd_motorista",
        Nome: "nome",
        "E-mail": "email",
        CPF: "cpf",
        Telefone: "tel_celular",
        CEP: "end_cep",
        Logradouro: "end_logradouro",
        Numero: "end_numero",
        Complemento: "end_complemento",
        Bairro: "end_bairro",
        Cidade: "end_cidade",
        UF: "end_uf",
        Pais: "pais.descricao",
        Status: "status_desc",
        Player: "equipamento.cd_player",
        Frame: "equipamento.mac_address",
        "Termo Aceito": "termo_aceito_desc",
        "Veiculo Fabricante": "complemento.veiculoFabricante.descricao",
        "Veiculo Modelo": "complemento.veiculo_modelo",
        "Veiculo Ano": "complemento.veiculo_ano",
        "Criado em": "createdAt",
        "Alterado em": "updatedAt"
      },
      filterText: "",
      urlApi:
        process.env.URL_API_BASE +
        "/motorista" +
        (this.status !== null && this.status !== undefined
          ? "/listar-por-status/" + this.status
          : ""),
      playerColumn: playerColumn,
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned"
        },
        {
          name: "nome",
          title: "Nome",
          sortField: "nome"
        },
        {
          name: "end_uf",
          title: "UF",
          sortField: "end_uf"
        },
        {
          name: "end_cidade",
          title: "Cidade",
          sortField: "end_cidade"
        },
        {
          name: "email",
          title: "E-mail",
          sortField: "email"
        },
        playerColumn,
        {
          name: "__slot:status_desc",
          title: "Status",
          sortField: "idc_status"
        },
        {
          name: "createdAt",
          title: "Criado em",
          sortField: "createdAt",
          callback: "formatarData"
        },
        "__slot:actions"
      ],
      sortOrder: [{ field: "createdAt", direction: "desc" }],
      moreParams: {},
      filtro: {
        uf: "",
        cidade: "",
        media_ini: "",
        media_fim: "",
        categoria: "",
        placa: ""
      },
      errorFiltroMessage: null,
      categorias: []
    };
  },
  mounted() {
    this.selectedFilter = this.filtroStatus
      .find(item => item.link === this.$route.path);
    this.$parent.$parent.$data.description = this.titulo;
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));

    AplicativoActions.listar().then(aplicativos => {
      aplicativos.forEach(item => {
        this.listaExcelFields[item.descricao + " Categoria"] =
          "app_" + item.cd_aplicativo + "_cd_aplicativo_categoria";
        this.listaExcelFields[item.descricao + " Segmento"] =
          "app_" + item.cd_aplicativo + "_cd_aplicativo_segmento";
        this.listaExcelFields[item.descricao + " Nota "] =
          "app_" + item.cd_aplicativo + "_nota_motorista";
        this.listaExcelFields[item.descricao + " Viagens Realizadas"] =
          "app_" + item.cd_aplicativo + "_viagens_realizadas";
        this.listaExcelFields[item.descricao + " Tempo de App"] =
          "app_" + item.cd_aplicativo + "_tempo_aplicativo";
        this.listaExcelFields[item.descricao + " Viagens Média"] =
          "app_" + item.cd_aplicativo + "_viagens_media";
      });
    });

    if (!this.status || this.status === 1) {
      this.playerColumn.visible = true;
      this.$refs.vuetable.normalizeFields();
    }

    AplicativoCategoriaActions.listar()
      .then(res => {
        this.categorias = res
        this.showModalLoader--
      })
      .catch((error) => {
        console.log(error.message)
        this.showModalLoader--
      })
  },
  computed: {
    httpOptions() {
      return {
        headers: { Authorization: "Bearer " + ActionsLogin.getToken() }
      };
    }
  },
  watch: {
    status: function(val) {
      if (this.status) {
        this.$parent.$parent.$data.description = this.titulo;
        this.urlApi =
          process.env.URL_API_BASE +
          "/motorista/listar-por-status/" +
          this.status;
        this.playerColumn.visible = this.status === 1;
        this.$refs.vuetable.normalizeFields();
      } else {
        this.$parent.$parent.$data.description = "Listar";
        this.urlApi = process.env.URL_API_BASE + "/motorista";
      }
    }
  },
  methods: {
    onChangeFilter(){
      this.$router.push(this.selectedFilter.link)
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onLoading() {
      this.$parent.$parent.$data.showModalLoader = true;
    },
    onLoaded() {
      this.$refs.vuetable.selectedTo = [];
      this.$parent.$parent.$data.showModalLoader = false;
    },
    onFilterSet(filterText) {
      this.moreParams.filter = filterText;
      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh();
        }
      });
    },
    doFilter() {
      this.$events.fire("filter-set", this.filterText);
    },
    filtrar() {
      if (
        this.filtro.uf ||
        this.filtro.cidade ||
        this.filtro.media_ini ||
        this.filtro.media_fim ||
        this.filtro.categoria ||
        this.filtro.placa
      ) {
        this.errorFiltroMessage = null;

        if (this.status) {
          this.urlApi =
            process.env.URL_API_BASE +
            "/motorista/listar-por-status/" +
            this.status;
        } else {
          this.urlApi = process.env.URL_API_BASE + "/motorista";
        }

        if (this.filtro.uf) {
          this.urlApi += "?end_uf=" + this.filtro.uf;
        }

        if (this.filtro.cidade) {
          this.urlApi +=
            (this.urlApi.indexOf("?") === -1 ? "?" : "&") +
            "end_cidade=" +
            this.filtro.cidade;
        }

        if (this.filtro.media_ini) {
          this.urlApi +=
            (this.urlApi.indexOf("?") === -1 ? "?" : "&") +
            "media_ini=" +
            this.filtro.media_ini;
        }

        if (this.filtro.media_fim) {
          this.urlApi +=
            (this.urlApi.indexOf("?") === -1 ? "?" : "&") +
            "media_fim=" +
            this.filtro.media_fim;
        }

        if (this.filtro.categoria) {
          this.urlApi +=
            (this.urlApi.indexOf("?") === -1 ? "?" : "&") +
            "categoria=" +
            this.filtro.categoria;
        }

        if (this.filtro.placa) {
          this.urlApi +=
            (this.urlApi.indexOf("?") === -1 ? "?" : "&") +
            "veiculo_placa=" +
            this.filtro.placa;
        }
      } else {
        if (this.status) {
          this.urlApi =
            process.env.URL_API_BASE +
            "/motorista/listar-por-status/" +
            this.status;
        } else {
          this.urlApi = process.env.URL_API_BASE + "/motorista";
        }
      }
    },
    limparFiltro() {
      this.filtro = {
        uf: "",
        cidade: "",
        media_ini: "",
        media_fim: "",
        categoria: ""
      }

      this.filtrar()
    },
    atualizar() {
      this.doFilter();
    },
    editar(rowData) {
      this.$router.push({
        path: "/motoristas/" + rowData.cd_motorista + "/e",
        query: { ret_url: this.$router.currentRoute.path }
      });
    },
    view(rowData) {
      this.$router.push({
        path: "/motoristas/" + rowData.cd_motorista,
        query: { ret_url: this.$router.currentRoute.path }
      });
    },
    excluir(rowData) {},
    formatarData(val) {
      let data = moment(val);
      if (data.isValid()) {
        return data.format("DD/MM/YYYY HH:mm");
      }
      return "";
    },
    async gerarExcel() {
      this.$parent.$parent.$data.showModalLoader = true;

      let url = `${this.urlApi}${(this.urlApi.indexOf("?") === -1 ? "?" : "&")}filter=${this.filterText}`
      let res = await MotoristaActions.listar(url);
      let categorias = await AplicativoCategoriaActions.listar();
      let segmentos = await AplicativoSegmentoActions.listar();
      let dicCategorias = {};
      let dicSegmentos = {};
      
      categorias.forEach(item => {
        dicCategorias[item.cd_aplicativo_categoria] = item.descricao;
      });
      segmentos.forEach(item => {
        dicSegmentos[item.cd_aplicativo_segmento] = item.descricao;
      });

      res.forEach((motorista, key) => {
        if (motorista.aplicativos && motorista.aplicativos.length > 0) {
          motorista.aplicativos.forEach(aplicativo => {
            res[key][
              "app_" + aplicativo.cd_aplicativo + "_cd_aplicativo_categoria"
            ] = dicCategorias[aplicativo.cd_aplicativo_categoria];
            res[key][
              "app_" + aplicativo.cd_aplicativo + "_cd_aplicativo_segmento"
            ] = dicSegmentos[aplicativo.cd_aplicativo_segmento];
            res[key][
              "app_" + aplicativo.cd_aplicativo + "_nota_motorista"
            ] = aplicativo.nota_motorista
              ? aplicativo.nota_motorista.toString().replace(".", ",")
              : "";
            res[key]["app_" + aplicativo.cd_aplicativo + "_observacao"] =
              aplicativo.observacao;
            res[key]["app_" + aplicativo.cd_aplicativo + "_status_desc"] =
              aplicativo.status_desc;
            res[key][
              "app_" + aplicativo.cd_aplicativo + "_viagens_realizadas"
            ] = aplicativo.viagens_realizadas;
            res[key]["app_" + aplicativo.cd_aplicativo + "_tempo_aplicativo"] =
              aplicativo.tempo_aplicativo;
            if (
              aplicativo.viagens_realizadas &&
              aplicativo.viagens_realizadas > 0 &&
              aplicativo.tempo_aplicativo &&
              aplicativo.tempo_aplicativo > 0
            ) {
              res[key]["app_" + aplicativo.cd_aplicativo + "_viagens_media"] = (
                aplicativo.viagens_realizadas / aplicativo.tempo_aplicativo
              )
                .toFixed(2)
                .toString()
                .replace(".", ",");
            } else {
              res[key][
                "app_" + aplicativo.cd_aplicativo + "_viagens_media"
              ] = 0;
            }
          });
        }

        if (motorista.motorista_equipamento && motorista.motorista_equipamento.length > 0) {
          res[key]["equipamento"] = motorista.motorista_equipamento[0].equipamento;
        }

        res[key].createdAt =
          motorista.createdAt === null
            ? null
            : moment.utc(motorista.createdAt).format("DD/MM/YYYY");
        res[key].updatedAt =
          motorista.updatedAt === null
            ? null
            : moment.utc(motorista.updatedAt).format("DD/MM/YYYY");
      });

      this.$parent.$parent.$data.showModalLoader = false;

      return res;
    },
    alterarStatus() {
      if (this.$refs.vuetable.selectedTo.length > 0) {
        this.titleModal = "Alterar Status";
        this.idc_status = "";
        this.errorMessageModal = "";
        this.errors = {};

        if (this.$refs.vuetable.selectedTo.length > 1) {
          this.bodyModal =
            "Todos os " +
            this.$refs.vuetable.selectedTo.length +
            " motoristas selecionados serão alterados para o novo status escolhido.";
        } else {
          this.bodyModal =
            "O motorista selecionado será alterado para o novo status escolhido.";
        }

        this.$modal.show("modal-motorista");
      } else {
        this.titleModal = "Erro";
        this.bodyModal = "Selecione ao menos um motorista para alterar.";
        this.$modal.show("modal-erro");
      }
    },
    modalMotoristaConfirma() {
      this.errorMessageModal = "";
      this.errors = {};

      if (this.idc_status) {
        if (this.$refs.vuetable.selectedTo.length > 0) {
          this.$parent.$parent.$data.showModalLoader = true;

          MotoristaActions
            .alterarStatusEmLote(
              this.$refs.vuetable.selectedTo,
              this.idc_status
            )
            .then(res => {
              this.$modal.hide("modal-motorista");
              this.$parent.$parent.$data.showModalLoader = false;
              this.$refs.vuetable.selectedTo = [];
              this.doFilter();
            })
            .catch(error => {
              console.log(error.message);
              this.errorMessageModal = "Ocorreu um erro ao alterar.";
              this.$parent.$parent.$data.showModalLoader = false;
            });
        }
      } else {
        this.errors.idc_status = "Este campo deve ser preenchido.";
        this.idc_status = null;
      }
    },
    novo() {
      this.$router.push("/motoristas/novo");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/motorista/Listar.vue